import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { parseUrlParams } from 'utils/parseUrlParams';
import Modal from 'components/Modal';
import { numberUnmask } from 'utils/unmasks';
import imgError from 'assets/images/error.svg';
import {
  newCheckInAction,
  NEW_CHECKIN,
  newNextAction,
  NEW_NEXT,
} from 'actions/navigation';
import Header from 'components/Header';
import Tooltip from 'components/Tooltip';
import Input from 'components/Form/Input';
import Validator from 'components/Validator';
import Progress from 'components/Progress';
import Button from 'components/Button';
import { useConfig } from '../../../config/ConfigContext';
import schema from './schema';

const Welcome = (props) => {
  const config = useConfig();
  const { validator: { values, errors }, checkinData, params } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(null);
  const firstName = get(checkinData, 'data.firstName') || get(checkinData, 'data.data.firstName');
  const workflowType = get(params, 'workflowType');

  useEffect(() => {
    const { dispatch } = props;
    if (get(checkinData, ['data']) === undefined) {
      const urlParams = parseUrlParams(window.location.search);
      dispatch(newCheckInAction({
        key: urlParams.key,
        workflowType,
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
      }));
    }
  }, []);

  useEffect(() => {
    const { fetch, navigate } = props;

    if (fetch.isDone[`${NEW_CHECKIN}`] && !fetch.isRunning[`${NEW_CHECKIN}`]) {
      const routeUrl = checkinData.data && checkinData.data.url && checkinData.data.url.replace(config.hostUrl, '');
      navigate(routeUrl);
    }

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url && checkinData.data.url.replace(config.hostUrl, '');
      navigate(routeUrl);
    }
  }, [checkinData]);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    const { dispatch, validator: { validate } } = props;
    if (validate(schema).isValid) {
      const urlParams = parseUrlParams(window.location.search);
      let formData;
      if (urlParams.to) {
        formData = {
          SsnLast4Digits: numberUnmask(values.ssn),
          to: urlParams.to,
        };
      } else {
        formData = {
          SsnLast4Digits: numberUnmask(values.ssn),
        };
      }
      setIsProgressVisible(true);
      dispatch(newNextAction({
        key: urlParams.key,
        workflowType,
        data: formData,
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
        fail: (err) => {
          console.log(err);
          setIsPopupVisible(true);
          setIsProgressVisible(false);
        },
      }));
    } else {
      console.log(errors);
      setIsPopupVisible(true);
      setIsProgressVisible(false);
    }
  };

  const handleInputChange = (event) => {
    const { validator: { onChangeHandler } } = props;
    onChangeHandler(event.target.name, event.target.value);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <div className="content">
        <h2>
          Welcome back,
          {' '}
          {firstName}
          !
        </h2>
        <p style={{ marginBottom: '16px' }}>Please enter the last 4 of your SSN to verify your identity</p>
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="form-group active">
                <Input
                  label="Last 4 Digits of Your SSN"
                  value={values.ssn || ''}
                  name="ssn"
                  tooltip="To protect your identity and for security purposes please enter the last 4 digits of your Social Security Number."
                  isMasked={[/\d/, /\d/, /\d/, /\d/]}
                  onChange={handleInputChange}
                  type="tel"
                  isRequired
                  hasError={errors.ssn}
                />
                <Tooltip>To protect your identity and for security purposes please enter the last 4 digits of your Social Security Number.</Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <Button
              className="btn btn-primary arrow"
              onClick={handleSubmitForm}
              title="Continue"
              isDisabled={values.ssn === undefined}
            />
          </div>
        </div>
      </div>
      {
        isPopupVisible
          && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="" />
              <p>Please try again.</p>
              <div onClick={handleClosePopup} className="btn btn-red">OK</div>
            </div>
          </Modal>
          )
      }
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

Welcome.propTypes = {
  navigate: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default Validator(schema)(connect(mapStateToProps)(Welcome));
